/**
 * Search popup.
 *
 * @type {obj}
 */
$('.open-popup-link').magnificPopup({
	type:'inline',
	midClick: true
});
